import Cookies from "js-cookie"

const getAgency = () => {
  let agency = ""
  console.log("Node Env ===", process.env.REACT_APP_NODE_ENV)
  if (typeof window !== "undefined" && process.env.REACT_APP_NODE_ENV === "production") {
    agency = window && window.location.host.split(".")[0]
    return agency
  } else {
    agency = Cookies.get("tenant") === "KSA" ? "bayut-stage" : "zameen"
    return agency
  }
}

export const AGENCY = getAgency()
